import React from 'react';
import { PaymentStatus } from '@apply/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCancel, faRefresh, faCheck } from '@fortawesome/free-solid-svg-icons';

interface PaymentStatusBubbleParameters {
    paymentStatus: PaymentStatus;
}

export const PaymentStatusBubble: React.FC<PaymentStatusBubbleParameters> = ({ paymentStatus }) => {
    let text = '';
    let className = '';
    let icon = undefined;

    switch (paymentStatus) {
        case PaymentStatus.InProgress:
            text = 'In Progress';
            className = 'filter-box-status payment-in-progress';
            icon = faClock;
            break;
        case PaymentStatus.Failure:
            text = 'Failed';
            className = 'filter-box-status payment-failure';
            icon = faCancel;
            break;
        case PaymentStatus.Refund:
            text = 'Refunded';
            className = 'filter-box-status payment-refund';
            icon = faRefresh;
            break;
        case PaymentStatus.RefundInProgress:
            text = 'Refund In Progress';
            className = 'filter-box-status payment-refund-in-progress';
            icon = faClock;
            break;
        case PaymentStatus.RefundFailure:
            text = 'Refund Failed';
            className = 'filter-box-status payment-refund-failed';
            icon = faCancel;
            break;
        case PaymentStatus.Success:
            text = 'Succeeded';
            className = 'filter-box-status payment-success';
            icon = faCheck;
            break;
    }

    return (
        <div className={className}>
            {text}
            <FontAwesomeIcon
                icon={icon}
                size={'1x'}
            />
        </div>
    );
};
